import React from 'react';

import './radio.scss';
const Radio = ({ value, checked, title, onChange }) => {
  return (
    <div className="pen">
      <div className="form__content">
        <label className="selected form-row custom-label">
          <input
            name="amt"
            type="radio"
            checked={checked}
            value={value}
            onChange={onChange}
          />
          <div className="row data-wrapper">
            <div className="data-cluster">
              <div className="input-text amount">{title}</div>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};

export default Radio;
